import type { ReactNode } from "react";
import type { GlyphTheme, GlyphType } from "../types";

interface ProductGlyphProps {
  type?: GlyphType;
  theme?: GlyphTheme;
}

export function ProductGlyph({ type = "bid", theme = "dark" }: ProductGlyphProps) {
  if (type === "bid" || type === "proposal" || type === "audit" || type === "jia") {
    const iconPath =
      type === "jia"
        ? "/assets/logo-mark-v3.svg"
        : theme === "light"
          ? `/assets/product-icon-${type}-light-imagegen-v3.png`
          : `/assets/product-icon-${type}-imagegen-v2.png`;

    return (
      <span
        className={`product-glyph product-glyph--${type} product-glyph--${theme}`}
        aria-hidden="true"
      >
        <img src={iconPath} alt="" />
      </span>
    );
  }

  const paths: Record<string, ReactNode> = {
    human: (
      <>
        <circle cx="12" cy="7.5" r="3.3" />
        <path d="M5.5 20c.7-4.1 3-6.2 6.5-6.2s5.8 2.1 6.5 6.2" />
      </>
    ),
    boundary: (
      <>
        <path d="M12 2.8 19 6v5.4c0 4.4-2.6 7.7-7 9.8-4.4-2.1-7-5.4-7-9.8V6z" />
        <path d="M8.5 12h7" />
      </>
    ),
    access: (
      <>
        <rect x="4" y="9" width="16" height="11" rx="1" />
        <path d="M8 9V6.8a4 4 0 0 1 8 0V9M12 13v3" />
      </>
    ),
    retention: (
      <>
        <path d="M5 7h14M8 7V4h8v3M7 10v9h10v-9" />
        <path d="M10 12v4M14 12v4" />
      </>
    ),
    review: (
      <>
        <path d="M4 12.5 9 17l11-11" />
        <path d="M20 12v8H4V4h10" />
      </>
    ),
  };

  return (
    <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      {paths[type] ?? paths.boundary}
    </svg>
  );
}
